import { Button, Modal } from "antd";
import { ReactNode } from "react";

interface AnalyzeModalProps {
  open: boolean;
  isLoading: boolean;
  close: any;
  width: number;
  handleConfirm?: any;
  text: ReactNode;
}

const AnalyzeModal = ({
  open,
  isLoading,
  close,
  text,
  width,
  handleConfirm,
}: AnalyzeModalProps) => {
  return (
    <Modal
      centered
      open={open}
      closeIcon={null}
      footer={[
        <div className="modal-button-group">
          <Button
            onClick={close}
            style={{ marginRight: 8, marginLeft: 8, marginBottom: 4 }}
          >
            No
          </Button>
          <Button
            type="primary"
            disabled={isLoading}
            loading={isLoading}
            onClick={handleConfirm}
            style={{ marginRight: 8, marginLeft: 8, marginBottom: 4 }}
          >
            Confirm
          </Button>
        </div>
      ]}
      width={width}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          height: 170,
          marginBottom: 24,
          marginRight: 8,
          marginLeft: 8,
          marginTop: 12,
        }}
      >
        <img
          alt="warning circle icon"
          src={require("../../../../assets/icons/warning-circle.png")}
          style={{ width: 22, height: 22, marginRight: 16 }}
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <p style={{ fontSize: 14, fontWeight: 400, lineHeight: "1.5rem", margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word", }}>
            {text}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default AnalyzeModal;
